import { useDispatch } from 'react-redux';
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAILURE,
  LOGOUT_SUCCESS,
  LOGOUT_REQUEST,
  LOGOUT_FAILURE,
} from '../../Utils/Constant';
import { useNavigate } from 'react-router-dom';

// Initialize state from localStorage
const getInitialAuthState = () => {
  try {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user'));
    const role = localStorage.getItem('role');
    if (token && user && role) {
      return {
        loading: false,
        error: null,
        user,
        token,
        isAuthenticated: true,
        role,
        forgotPasswordSuccess: false,
        verifyOtpSuccess: false,
      };
    }
  } catch (e) {
    console.error('Error reading from localStorage:', e);
  }

  return {
    loading: false,
    error: null,
    user: null,
    token: null,
    isAuthenticated: false,
    role: null,
    forgotPasswordSuccess: false,
    verifyOtpSuccess: false,
  };
};



const initialState = getInitialAuthState();

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    // === Request Actions ===
    case LOGIN_REQUEST:
    case FORGOT_PASSWORD_REQUEST:
    case VERIFY_OTP_REQUEST:
    case RESET_PASSWORD_REQUEST:
    case CREATE_USER_REQUEST:
    case LOGOUT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        forgotPasswordSuccess: action.type === FORGOT_PASSWORD_REQUEST ? false : state.forgotPasswordSuccess,
        verifyOtpSuccess: action.type === VERIFY_OTP_REQUEST ? false : state.verifyOtpSuccess,
      };

    // === Success Actions ===
    case LOGIN_SUCCESS:
      {
        const { tokens, user } = action.payload;
        
        const accessToken = tokens;
        const role = user?.role;

        try {
          localStorage.setItem('token', accessToken);
          localStorage.setItem('user', JSON.stringify(user));
          localStorage.setItem('role', role);
        } catch (err) {
          console.error('Failed to write to localStorage:', err);
        }

        return {
          ...state,
          loading: false,
          isAuthenticated: true,
          user,
          token: accessToken,
          role,
        };
      }

    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        forgotPasswordSuccess: true,
      };

    case VERIFY_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        verifyOtpSuccess: true,
      };

    case RESET_PASSWORD_SUCCESS:
      {
        const { token, user, role } = action.payload;

        if (token && user && role) {
          try {
            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify(user));
            localStorage.setItem('role', role);
          } catch (err) {
            console.error('localStorage error on reset:', err);
          }
        }

        return {
          ...state,
          loading: false,
          isAuthenticated: true,
          user: user || null,
          token: token || null,
          role: role || null,
        };
      }

    case CREATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
      };

     case LOGOUT_SUCCESS:
        return {
          ...state,
          loading: false,
          isAuthenticated: false,
          user: null,
          token: null,
          role: null,
          error: null,
        };
    // === Failure Actions ===
    case LOGIN_FAILURE:
    case FORGOT_PASSWORD_FAILURE:
    case VERIFY_OTP_FAILURE:
    case RESET_PASSWORD_FAILURE:
    case CREATE_USER_FAILURE:
    case LOGOUT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        forgotPasswordSuccess: action.type === FORGOT_PASSWORD_FAILURE ? false : state.forgotPasswordSuccess,
        verifyOtpSuccess: action.type === VERIFY_OTP_FAILURE ? false : state.verifyOtpSuccess,
      };

    default:
      return state;
  }
}
